import React from "react";


const FooterBanner =() =>{

    return (
        <div className="footer-banner-container">
        <div className="" style={{"textAlign":"center"}} >
              <h1 type="button">ROJO</h1>
        </div>
      </div>
    )
}

export default FooterBanner